import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigModel } from './models/app-config.model';
import { environment } from 'src/environments/environment';

const APP_CONFIG_KEY_NAME: string = 'appConfigKeyName';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private http: HttpClient) { }

  load() {

    this.http.get(`./assets/app-config.${environment.language}.json`).subscribe(res => {

      localStorage.removeItem(APP_CONFIG_KEY_NAME);
      localStorage.setItem(APP_CONFIG_KEY_NAME, JSON.stringify(res));

    }, err => {
      console.log('Ocorreu um erro ao tentar recuperar o arquivo de configuração', err);
    });
  }

  get(): AppConfigModel | null {

    let configData = localStorage.getItem(APP_CONFIG_KEY_NAME);
    let config: AppConfigModel | null = configData != null ? <AppConfigModel>JSON.parse(configData) : null;

    if (environment.qa && config != null) {
      config!.apiUrl = config?.apiUrlQA;
    }

    return config;
  }
}
